module.exports = __webpack_public_path__ + "img/jian.60da4059.svg";